module.exports = __webpack_public_path__ + "static/media/StartPage.46b3abaa.md";